import { ref } from "vue";

declare const __APP_VERSION__: string;

export function useVersion() {
  return ref(__APP_VERSION__);
}
